export const isValidEmail = (email) => {
    const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return validEmailRegex.test(email);
};
//# sourceMappingURL=isValidEmail.js.map